import type { FocusEvent } from "react";

/**
 * A collapsible field shrinks back to one line on blur, but the browser keeps
 * the scroll position from editing, so the first line would stay hidden.
 */
export const resetCollapsedTextAreaScroll = (
    event: FocusEvent<HTMLTextAreaElement>,
) => {
    event.currentTarget.scrollTop = 0;
};
